var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.4 9.4c-1.7.3-3.2.9-4.6 2L3 8.5v7h7l-2.7-2.7c3.7-2.6 8.8-1.8 11.5 1.9.2.3.4.5.5.8l1.8-.9c-2.2-3.8-6.4-5.9-10.7-5.2Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }